import { useSyncExternalStore } from 'react';

/**
 * Le volume de la musique des indices (l'extrait sonore), a part des effets :
 * les bips sont synthetises et discrets, une chanson ne l'est pas.
 *
 * Persiste comme le theme et le son — regle une fois, jamais a refaire. Un
 * petit magasin a abonnes plutot qu'un etat React : la barre du haut ecrit,
 * `AudioClue` (loin dans l'arbre) lit, sans rien se passer en props.
 */
const KEY = 'guess:music-volume';
const DEFAULT_VOLUME = 0.6;

function read(): number {
  try {
    const saved = window.localStorage.getItem(KEY);
    if (saved !== null) {
      const value = Number(saved);
      if (Number.isFinite(value)) return Math.min(1, Math.max(0, value));
    }
  } catch {
    /* navigation privee : valeur par defaut pour cette session */
  }
  return DEFAULT_VOLUME;
}

let volume = read();
const listeners = new Set<() => void>();

export const musicVolume = {
  get(): number {
    return volume;
  },
  set(value: number): void {
    volume = Math.min(1, Math.max(0, value));
    try {
      window.localStorage.setItem(KEY, String(volume));
    } catch {
      /* sans importance */
    }
    for (const listener of listeners) listener();
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useMusicVolume(): number {
  return useSyncExternalStore(musicVolume.subscribe, musicVolume.get);
}
